// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ListItemIcon":"bcb_a bhk_kb","ListItemIcon--empty":"bcb_b bhk_fj"};